import config from '@/config'

window.setInterval(async () => {
  try {
    // @note: version set in the deployment in the pipeline and the value will set as the result of git rev-parse HEAD
    const currentVersion = config.release

    // v added to prevent that the browser return cached file
    const serverVersionFile = await fetch(
      `${config.baseUrl}/version.json?v=${new Date().getTime()}`
    )
    const serverVersionJson = await serverVersionFile.json()
    const serverVersion = serverVersionJson.version

    const alert = document.getElementById('change-version-alert')
    if (alert) {
      alert.style.display = currentVersion !== serverVersion ? 'block' : 'none'
    }
  } catch (error) {
    console.log('error', error)
  }
}, 120000)
